import BuyBoxSendEmail from 'views/components/organisms/BuyBoxWithVariants/BuyBoxSendEmail'

const BuyBoxSendEmailFormContainer = () => {
  return (
    <div id="email-on-availability-box">
      <BuyBoxSendEmail />
    </div>
  )
}
export default BuyBoxSendEmailFormContainer
